export default "__VITE_ASSET__DQphTx2v__"